import { FundClassificationProcess } from '../fund-classification-process'
import { FundRuleFactory } from '../rules/fund-rule-factory'
import { FundRuleName } from '../rules/fund-rule-name'
import { IFundRule } from '../rules/ifund-rule'
import { FundCategoryModel } from './fund-category-model'

export class FilterHandlerContext {
  constructor(
    private readonly fundClassificationProcess: FundClassificationProcess,
    private readonly fundRuleFactory: FundRuleFactory,
  ) {}

  getRule(fundRuleName: FundRuleName): IFundRule {
    return this.fundRuleFactory.getFundRule(fundRuleName)
  }

  getFundCollection(fundRuleName: FundRuleName): FundCategoryModel {
    return this.fundClassificationProcess
      .getFundClassificationMap()
      .get(fundRuleName)
  }
}
